import type { Role } from '@/lib/auth-context';
import type { ModuleKey } from '@/lib/modules';
import { fetchApi } from '@/services/api-client';
import type { components } from '@/services/openapi';

export const AUTH_PATH = '/auth';

export type AdminUser = {
  id: string;
  email: string;
  fullName: string | null;
  role: Role;
  modules: ModuleKey[];
};

export type LoginResponse = {
  access_token: string;
  user: AdminUser;
};

export type LoginRequest = components['schemas']['LoginRequest'];
export type GoogleLoginRequest = components['schemas']['GoogleLoginRequest'];

export const authApi = {
  login: (email: string, password: string) =>
    fetchApi<LoginResponse>(`${AUTH_PATH}/login`, {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),
  loginWithGoogle: (idToken: string) =>
    fetchApi<LoginResponse>(`${AUTH_PATH}/google`, {
      method: 'POST',
      body: JSON.stringify({ idToken }),
    }),
  getMe: () => fetchApi<AdminUser>(`${AUTH_PATH}/me`),
  logout: () => fetchApi<void>(`${AUTH_PATH}/logout`, { method: 'POST' }),
};
